enum EQuestPartsType {
	start = 'start',
	walkthrough = 'walkthrough',
	info = 'info',
	results = 'results',
	quiz = 'quiz',
	unset = 'unset'
}

enum EQuestPartSubtype {
	code = 'code',
	information = 'information',
	quiz = 'quiz'
}

enum EQuestViewType {
	prelude = 'prelude',
	parts = 'parts',
	postlude = 'postlude',
	summary = 'summary'
}

enum EQuestType {
	build = 'build',
	mcq = 'mcq',
	ctf = 'ctf',
	unset = 'unset'
}

enum EPartAction {
	VALIDATE_PART = 'VALIDATE_PART',
	ADD_HINT = 'ADD_HINT',
	INIT_PARTS = 'INIT_PARTS'
}

enum EAvailablePartIndexesAction {
	INIT = 'INIT',
	ADD = 'ADD'
}

export { EAvailablePartIndexesAction, EPartAction, EQuestPartSubtype, EQuestPartsType, EQuestType, EQuestViewType };
